import { InterviewQuestionType } from '@components/pass/interview/start/context/interviewContext';

export class InterviewPracticeCreateRq {
  pooledQuestionSns: number[];

  constructor(selectedQuestionList: InterviewQuestionType[]) {
    this.pooledQuestionSns = selectedQuestionList.map((question) => question.sn);
  }
}
